import React, { useState, useEffect, useCallback } from "react";
import "../../Styles/yellocalfcss/AssetsRegisterReport.css";
import { simplePostCall } from "../../api/ApiServices";
import ApiConfig from "../../api/ApiConfig";
import ScaleLoader from "react-spinners/ScaleLoader";
import { formatNumber } from "../../utils/formatNumber";

const Assets_Register_Report = () => {
  const customer_currency = (localStorage.getItem("customer_currency") || "").replace(/"/g, "");
  const [reportData, setReportData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [assetType, setAssetType] = useState("");
  const [startDate, setStartDate] = useState("2025-01-01");
  const [endDate, setEndDate] = useState("2026-12-31");

  const [assetTypeList, setAssetTypeList] = useState([]);

  const fetchTypeDropdown = async () => {
    try {
      const payload = {
        customer_id: Number(localStorage.getItem("customer_id")),
        api_key: localStorage.getItem("api_key"),
        user_id: localStorage.getItem("user_id") || "56950",
      };

      const res = await simplePostCall(
        ApiConfig.typesdropdownAssies,
        JSON.stringify(payload)
      );

      if (res && res.result && res.data) {
        setAssetTypeList(res.data);
      }
    } catch (err) {
      console.error("Error fetching dropdown types:", err);
    }
  };

  const fetchInitialData = useCallback(async (overrides = {}) => {
    setLoading(true);
    try {
      const payload = {
        customer_id: Number(localStorage.getItem("customer_id")) || 1005,
        api_key: localStorage.getItem("api_key") || "b9359f494e77b6589ce12dd62518c585",
        language: "en",
        user_id: localStorage.getItem("user_id") || 14857,
        page: 1,
        limit: 99999999999,
        start_date: overrides.startDate ?? startDate,
        end_date: overrides.endDate ?? endDate,
        asset_type: overrides.assetType ?? assetType,
        search: "",
      };

      const response = await simplePostCall(
        ApiConfig.assetmodereportports,
        JSON.stringify(payload)
      );

      if (response && response.result && response.data) {
        setReportData(response.data);
      } else {
        setReportData([]);
      }
    } catch (error) {
      console.error("Error fetching report:", error);
      setReportData([]);
    } finally {
      setLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    fetchTypeDropdown();
    fetchInitialData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    fetchInitialData({ assetType });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [assetType]);

  const totalAmount = reportData.reduce(
    (sum, item) => sum + Number(item.asset_amount || 0),
    0
  );

  const handleSearch = () => {
    fetchInitialData();
  };

  const handleClear = () => {
    const defStart = "2025-01-01";
    const defEnd = "2026-12-31";
    setAssetType("");
    setStartDate(defStart);
    setEndDate(defEnd);
    fetchInitialData({ assetType: "", startDate: defStart, endDate: defEnd });
  };

  return (
    <div className="fee-container">
      <div className="special-header panel-white-all">
        <h4 className="page-title">Assets Register Report</h4>
        <button className="btn btn-sm btn-primary">Export</button>
      </div>

      <div className="yc-list-body">
        <div className="yc-list-filter">
          <select
            className="form-select"
            value={assetType}
            onChange={(e) => setAssetType(e.target.value)}
          >
            <option value="">All Types</option>
            {assetTypeList.map((type, idx) => {
              const val =
                typeof type === "string"
                  ? type
                  : type.asset_type ?? type.asset_type_name ?? type.name ?? type.value ?? "";
              const label =
                typeof type === "string"
                  ? type
                  : type.asset_type ?? type.asset_type_name ?? type.name ?? type.label ?? String(val);
              if (!val) return null;
              return (
                <option key={idx} value={val}>
                  {label}
                </option>
              );
            })}
          </select>

          <input
            type="date"
            className="form-control"
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
          />

          <span className="yc-filter-label">to</span>

          <input
            type="date"
            className="form-control"
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
          />

          <button
            onClick={handleSearch}
            disabled={loading}
            className="btn btn-primary"
          >
            {loading ? "Searching..." : "Search"}
          </button>

          <button onClick={handleClear} className="btn btn-secondary">
            Clear
          </button>
        </div>

        <div className="yc-list-thead-card">
          <div className="yc-list-grid yc-list-grid-6">
            <div className="yc-list-cell">Sr.No</div>
            <div className="yc-list-cell">Asset Type</div>
            <div className="yc-list-cell">Asset Name</div>
            <div className="yc-list-cell">Description</div>
            <div className="yc-list-cell">Date</div>
            <div className="yc-list-cell">Amount</div>
          </div>
        </div>

        {loading ? (
          <div className="d-flex justify-content-center align-items-center" style={{ height: "20vh" }}>
            <ScaleLoader color="#F4BB44" />
          </div>
        ) : reportData.length > 0 ? (
          <div className="yc-list-row-list">
            {reportData.map((item, index) => (
              <div key={item.asset_id || index} className="yc-list-row-card">
                <div className="yc-list-grid yc-list-grid-6">
                  <div className="yc-list-cell">{index + 1}</div>
                  <div className="yc-list-cell">{item.asset_type}</div>
                  <div className="yc-list-cell">{item.asset_name}</div>
                  <div className="yc-list-cell">{item.asset_description}</div>
                  <div className="yc-list-cell">{new Date(item.asset_date).toLocaleDateString()}</div>
                  <div className="yc-list-cell">{customer_currency} {formatNumber(item.asset_amount)}</div>
                </div>
              </div>
            ))}
            <div className="yc-list-row-card yc-list-row-total">
              <div className="yc-list-grid yc-list-grid-6">
                <div className="yc-list-cell"></div>
                <div className="yc-list-cell"></div>
                <div className="yc-list-cell"></div>
                <div className="yc-list-cell"></div>
                <div className="yc-list-cell fw-bold">Total Amount</div>
                <div className="yc-list-cell yc-amount-positive">
                  {customer_currency} {formatNumber(totalAmount)}
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div className="yc-empty-state">No records found.</div>
        )}
      </div>
    </div>
  );
};

export default Assets_Register_Report;
